module.exports = __webpack_public_path__ + "media/images/img_mansion_selling_2-4a349369353a96c13019cc6b4ce32f1f.png";